export default __webpack_public_path__ + "static/media/mercato.73048429.jpeg";